module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/title-block-1b63753f28d6f05513516b5a9933efc2.png";